import { NEW_PROFESSION_ROUTE_META } from './professions/professionSeo.js'

const DEFAULT_IMAGE = '/public-assets/all-mobile-businesses/main-scenes/offlico-all-mobile-businesses-hero-professional.webp'

export const MARKETING_SITE_URL = 'https://www.offlico.com'
export const MARKETING_DEFAULT_IMAGE = DEFAULT_IMAGE

export const BUSINESS_PROFESSION_SEO = [
  {
    pluralSlug: 'chiropodists',
    singularSlug: 'chiropodist',
    audience: 'chiropodists, podiatrists and foot health practitioners',
    shortAudience: 'chiropodists and podiatrists',
    heroAudience: 'chiropodists',
    hubTitle: 'Podiatry and Chiropody Software UK',
    practiceTitle: 'Podiatry Practice Management Software UK',
    practiceHeading: 'Is your practice software built for mobile work?',
    recordDetail: 'treatment notes',
    routeTitles: {
      admin: 'Chiropody Admin Software for Mobile Practices',
      leads: 'Chiropodist Lead Generation Software UK',
      booking: 'Podiatry Booking Software for Home Visits',
      reminders: 'Podiatry Appointment Reminder Software',
      records: 'Podiatry Client Record Software for Home Visits',
    },
    searchIntents: {
      hub: 'podiatry and chiropody software',
      admin: 'chiropody admin software',
      leads: 'chiropodist lead generation software',
      booking: 'podiatry booking software',
      reminders: 'podiatry appointment reminder software',
      records: 'podiatry client record software',
      practice: 'podiatry practice management software',
    },
    description: 'Manage bookings, records, reminders and payments with Offlico, built for mobile chiropodists, podiatrists and foot health practitioners.',
    images: {
      hub: '/public-assets/chiropodists/offlico-mobile-chiropodist-hero-foot-treatment.jpg',
      admin: '/public-assets/chiropodists/offlico-chiropodist-admin-overload-evening-paperwork-hero.webp',
      leads: '/public-assets/chiropodists/offlico-chiropodist-lead-generation-waiting-between-home-visits-hero.jpg',
      booking: '/public-assets/chiropodists/offlico-chiropodist-online-booking-home-visit-missed-calls-hero.webp',
      reminders: '/public-assets/chiropodists/offlico-chiropodist-appointment-reminders-home-visit-door-phone-hero.jpg',
      records: '/public-assets/chiropodists/offlico-chiropodist-client-records-evening-paperwork-hero.jpg',
    },
  },
  {
    pluralSlug: 'mobile-hairdressers',
    singularSlug: 'mobile-hairdresser',
    audience: 'mobile hairdressers and self-employed hairstylists',
    shortAudience: 'mobile hairdressers',
    heroAudience: 'hairdressers',
    hubTitle: 'Mobile Hairdresser Booking Software UK',
    practiceTitle: 'Mobile Hairdresser Business Software UK',
    practiceHeading: 'Is your practice software built for mobile work?',
    recordDetail: 'colour notes',
    description: 'Booking and business software for mobile hairdressers. Manage appointments, client records, reminders, payments, mileage and daily admin in one app.',
    images: {
      hub: '/public-assets/mobile-hairdressers/main-scenes/offlico-mobile-hairdresser-main-hero-hair-treatment.jpg',
      admin: '/public-assets/mobile-hairdressers/main-scenes/offlico-mobile-hairdresser-admin-overload-high-quality-hero.webp',
      leads: '/public-assets/mobile-hairdressers/main-scenes/offlico-mobile-hairdresser-lead-generation-waiting-between-home-visits-hero.jpg',
      booking: '/public-assets/mobile-hairdressers/main-scenes/offlico-mobile-hairdresser-online-booking-home-visit-missed-calls-hero.webp',
      reminders: '/public-assets/mobile-hairdressers/main-scenes/offlico-mobile-hairdresser-appointment-reminders-home-visit-door-phone-hero.jpg',
      records: '/public-assets/mobile-hairdressers/main-scenes/offlico-mobile-hairdresser-client-records-evening-paperwork-hero.jpg',
    },
  },
  {
    pluralSlug: 'cleaners',
    singularSlug: 'cleaner',
    audience: 'self-employed cleaners and mobile cleaning businesses',
    shortAudience: 'cleaning businesses',
    heroAudience: 'cleaners',
    hubTitle: 'Cleaning Business Software and Booking App UK',
    practiceTitle: 'Cleaning Business Management Software UK',
    practiceHeading: 'Is your cleaning business software built for mobile work?',
    recordDetail: 'cleaning preferences',
    description: 'Cleaning business software for bookings, repeat visits, client details, reminders, invoicing, payments and mobile team admin in one connected app.',
    images: {
      hub: '/public-assets/cleaners/main-scenes/offlico-mobile-cleaner-main-hero-home-cleaning.jpg',
      admin: '/public-assets/cleaners/main-scenes/offlico-cleaner-admin-overload-high-quality-hero.webp',
      leads: '/public-assets/cleaners/main-scenes/offlico-cleaner-lead-generation-waiting-between-home-visits-hero.jpg',
      booking: '/public-assets/cleaners/main-scenes/offlico-cleaner-online-booking-home-visit-missed-calls-hero.webp',
      reminders: '/public-assets/cleaners/main-scenes/offlico-cleaner-appointment-reminders-home-visit-door-phone-hero.jpg',
      records: '/public-assets/cleaners/main-scenes/offlico-cleaner-client-records-evening-paperwork-hero.jpg',
    },
  },
  {
    pluralSlug: 'gardeners',
    singularSlug: 'gardener',
    audience: 'self-employed gardeners and mobile gardening businesses',
    shortAudience: 'gardening businesses',
    heroAudience: 'gardeners',
    hubTitle: 'Gardening Business Software and Booking App UK',
    practiceTitle: 'Gardening Business Management Software UK',
    practiceHeading: 'Is your gardening business software built for mobile work?',
    recordDetail: 'gardening preferences',
    description: 'Gardening business software for recurring jobs, scheduling, client access notes, reminders, invoices, payments, mileage and mobile admin.',
    images: {
      hub: '/public-assets/gardeners/main-scenes/offlico-mobile-gardener-hero-garden-work.webp',
      admin: '/public-assets/gardeners/main-scenes/offlico-gardener-admin-overload-high-quality-hero.webp',
      leads: '/public-assets/gardeners/main-scenes/offlico-gardener-lead-generation-waiting-between-home-visits-hero.jpg',
      booking: '/public-assets/gardeners/main-scenes/offlico-gardener-online-booking-home-visit-missed-calls-hero.webp',
      reminders: '/public-assets/gardeners/main-scenes/offlico-gardener-appointment-reminders-home-visit-door-phone-hero.jpg',
      records: '/public-assets/gardeners/main-scenes/offlico-gardener-client-records-evening-paperwork-hero.jpg',
    },
  },
  {
    pluralSlug: 'ear-wax-removal-specialists',
    singularSlug: 'ear-wax-removal-specialist',
    audience: 'mobile ear wax removal specialists and ear care clinics',
    shortAudience: 'ear wax removal clinics',
    heroAudience: 'ear wax removal specialists',
    hubTitle: 'Ear Wax Removal Clinic Software UK',
    practiceTitle: 'Ear Care Practice Management Software UK',
    practiceHeading: 'Is your ear wax removal business software built for mobile work?',
    recordDetail: 'ear wax removal preferences',
    routeTitles: {
      booking: 'Online Booking for Ear Wax Removal Clinics',
    },
    description: 'Ear care clinic software for ear wax removal and microsuction businesses. Manage bookings, treatment records, reminders, payments and mobile visits.',
    images: {
      hub: '/public-assets/ear-wax-removal-specialists/main-scenes/offlico-mobile-ear-wax-removal-specialist-hero-ear-treatment.webp',
      admin: '/public-assets/ear-wax-removal-specialists/main-scenes/offlico-ear-wax-removal-specialist-admin-overload-high-quality-hero.webp',
      leads: '/public-assets/ear-wax-removal-specialists/main-scenes/offlico-ear-wax-removal-specialist-lead-generation-waiting-between-home-visits-hero.jpg',
      booking: '/public-assets/ear-wax-removal-specialists/main-scenes/offlico-ear-wax-removal-specialist-online-booking-home-visit-missed-calls-hero.webp',
      reminders: '/public-assets/ear-wax-removal-specialists/main-scenes/offlico-ear-wax-removal-specialist-appointment-reminders-home-visit-door-phone-hero.jpg',
      records: '/public-assets/ear-wax-removal-specialists/main-scenes/offlico-ear-wax-removal-specialist-client-records-evening-paperwork-hero.jpg',
    },
  },
]

const professionRouteSeo = {
  '': (profession) => ({
    title: profession.hubTitle,
    description: profession.description,
    image: profession.images.hub,
    pageHeading: `The best software for mobile ${profession.heroAudience}`,
    pageIntro: 'Run home visits, client records, payments, mileage and bookkeeping in one connected system.',
    searchIntent: profession.searchIntents?.hub || `${profession.shortAudience} software`,
  }),
  'admin-overload': (profession) => ({
    title: profession.routeTitles?.admin || `Admin Software for ${titleCase(profession.shortAudience)}`,
    description: `Reduce after-hours admin for ${profession.audience}. Keep bookings, records, reminders and payments connected in Offlico.`,
    image: profession.images.admin,
    pageHeading: 'Spending too much time on admin?',
    pageIntro: 'Offlico keeps your appointments, clients, reminders, payments and paperwork in one place so work does not keep following you home.',
    searchIntent: profession.searchIntents?.admin || `${profession.shortAudience} admin software`,
  }),
  'lead-generation': (profession) => ({
    title: profession.routeTitles?.leads || `Lead Generation for ${titleCase(profession.shortAudience)}`,
    description: `Receive suitable local requests for ${profession.audience}, review the details and turn the right enquiries into appointments.`,
    image: profession.images.leads,
    pageHeading: 'Could you take on more clients?',
    pageIntro: 'See nearby customer requests and contact the ones that fit your working day.',
    searchIntent: profession.searchIntents?.leads || `${profession.shortAudience} lead generation`,
  }),
  'online-booking': (profession) => ({
    title: profession.routeTitles?.booking || `Online Booking Software for ${titleCase(profession.shortAudience)}`,
    description: `Let customers request or book appointments online with service, postcode and timing details ready for ${profession.audience}.`,
    image: profession.images.booking,
    pageHeading: 'Are missed calls losing you bookings?',
    pageIntro: 'Offlico lets clients book online while you work, with availability that can fit around your existing appointments and travel.',
    searchIntent: profession.searchIntents?.booking || `${profession.shortAudience} online booking software`,
  }),
  'appointment-reminders': (profession) => ({
    title: profession.routeTitles?.reminders || `Appointment Reminders for ${titleCase(profession.shortAudience)}`,
    description: `Send automatic reminders for ${profession.audience}, with timing connected to each appointment and client record.`,
    image: profession.images.reminders,
    pageHeading: 'Are forgotten appointments costing you time, fuel and income?',
    pageIntro: 'Offlico automatically reminds clients before every home visit, helping you avoid wasted journeys and spend less time chasing.',
    searchIntent: profession.searchIntents?.reminders || `${profession.shortAudience} appointment reminder software`,
  }),
  'client-records': (profession) => ({
    title: profession.routeTitles?.records || `Client Record Software for ${titleCase(profession.shortAudience)}`,
    description: `Keep client details, appointment history, notes, documents and repeat-visit information organised for ${profession.audience}.`,
    image: profession.images.records,
    pageHeading: 'Struggling to manage your client records?',
    pageIntro: `Offlico makes it easier to keep client details, ${profession.recordDetail}, documents, appointments and repeat visits organised in one place.`,
    searchIntent: profession.searchIntents?.records || `${profession.shortAudience} client record software`,
  }),
  'practice-management-software': (profession) => ({
    title: profession.practiceTitle,
    description: `Compare software for ${profession.audience}, including bookings, client records, reminders, payments and daily admin.`,
    image: profession.images.hub,
    pageHeading: profession.practiceHeading,
    pageIntro: `Offlico brings appointments, client records, ${profession.recordDetail}, reminders, payments, mileage and home visits together in one ${profession.pluralSlug === 'cleaners' || profession.pluralSlug === 'gardeners' || profession.pluralSlug === 'ear-wax-removal-specialists' ? 'business management' : 'practice management'} system.`,
    searchIntent: profession.searchIntents?.practice || `${profession.shortAudience} business management software`,
  }),
}

function titleCase(value) {
  return String(value || '').replace(/\b\w/g, (letter) => letter.toUpperCase())
}

export function buildBusinessProfessionRouteMeta() {
  return BUSINESS_PROFESSION_SEO.flatMap((profession) =>
    Object.entries(professionRouteSeo).map(([suffix, buildSeo]) => ({
      path: `/for-businesses/${profession.pluralSlug}${suffix ? `/${suffix}` : ''}`,
      ...buildSeo(profession),
      profession,
    })),
  )
}

export const BUSINESS_PROFESSION_ROUTE_META = buildBusinessProfessionRouteMeta()

export const FEATURE_ROUTE_SEO = [
  {
    slug: 'calendar',
    title: 'Appointment Scheduling for Mobile Businesses',
    description: 'Plan appointments, client addresses, services, payment status and daily work in one scheduling calendar built for mobile businesses.',
    image: '/public-assets/features/calendar/offlico-calendar-appointment-cards-poster.jpg',
  },
  {
    slug: 'online-booking-page',
    title: 'Online Booking for Mobile Service Businesses',
    description: 'Let customers book or request services online while Offlico keeps availability, appointment details, reminders and payments connected.',
    image: '/public-assets/features/online-booking/offlico-online-booking-laptop-loop-poster.jpg',
  },
  {
    slug: 'ai-receptionist',
    title: 'AI Receptionist for Mobile Service Businesses',
    description: 'Answer customer calls, explain services and book suitable appointments with an AI receptionist connected to the Offlico working day.',
    image: '/public-assets/features/feature-cells/ai-receptionist/offlico-ai-receptionist-answers-calls-while-you-work.webp',
  },
  {
    slug: 'smart-routing',
    title: 'Route Planning Software for Mobile Appointments',
    description: 'Plan mobile appointments around customer locations, travel time and a realistic working day with Offlico route-aware scheduling.',
    image: '/public-assets/features/smart-routing/offlico-smart-routing-feature-loop-poster.jpg',
  },
  {
    slug: 'services-and-prices',
    title: 'Service Pricing and Booking Software',
    description: 'Store service names, prices, durations and descriptions once, then use them across online booking, appointments, invoices and reports.',
    image: '/public-assets/features/services-and-prices/offlico-services-and-prices-feature-loop-poster.jpg',
  },
  {
    slug: 'client-records',
    title: 'Client Management Software for Mobile Businesses',
    description: 'Keep client contact details, addresses, appointment history, notes, documents and repeat-visit information in one organised record.',
    image: '/public-assets/features/client-records/offlico-client-records-feature-loop-poster.jpg',
  },
  {
    slug: 'reminders',
    title: 'Appointment Reminder Software for Small Businesses',
    description: 'Send automatic appointment reminders connected to each booking, helping mobile service businesses reduce manual chasing and missed visits.',
    image: '/public-assets/features/reminders/offlico-reminders-feature-loop-poster.jpg',
  },
  {
    slug: 'payments',
    title: 'Payment Tracking for Mobile Service Businesses',
    description: 'Accept and record payments against the correct appointment and client, with paid, pending and overdue work kept clearly organised.',
    image: '/public-assets/features/payments/offlico-payments-feature-loop-poster.jpg',
  },
  {
    slug: 'tap-to-pay',
    title: 'Tap to Pay for Mobile Service Businesses',
    description: 'Take contactless payments from a supported iPhone, with each payment connected to the appointment and client record.',
    image: '/public-assets/features/tap-to-pay/offlico-tap-to-pay-feature-loop-poster.jpg',
  },
  {
    slug: 'invoices-and-receipts',
    title: 'Invoice and Receipt App for Mobile Businesses',
    description: 'Create invoices and receipts from existing appointment, client, service and payment details without rebuilding the same information.',
    image: '/public-assets/features/invoices-and-receipts/offlico-invoices-and-receipts-feature-loop-poster.jpg',
  },
  {
    slug: 'documents-and-notes',
    title: 'Client Notes and Document Management',
    description: 'Attach notes, forms, photos, files and documents to the correct client or appointment so important records stay easy to find.',
    image: '/public-assets/features/documents-and-notes/offlico-documents-and-notes-feature-loop-poster.jpg',
  },
  {
    slug: 'mileage-tracking',
    title: 'Mileage Tracking App for Sole Traders',
    description: 'Record business mileage for mobile appointments and keep a clearer travel log for expenses, tax admin and accountant exports.',
    image: '/public-assets/features/mileage-tracking/offlico-mileage-tracking-feature-loop-poster.jpg',
  },
  {
    slug: 'bookkeeping',
    title: 'Bookkeeping App for Mobile Businesses',
    description: 'Keep income, expenses, receipts, mileage and payment records organised alongside the work that created them.',
    image: '/public-assets/features/bookkeeping/offlico-bookkeeping-feature-loop-poster.jpg',
  },
  {
    slug: 'reports',
    title: 'Business Reports for Mobile Service Businesses',
    description: 'See practical summaries of revenue, appointments, clients and outstanding payments without rebuilding the figures in a spreadsheet.',
    image: '/public-assets/features/reports/offlico-reports-feature-loop-poster.jpg',
  },
  {
    slug: 'public-profile',
    title: 'Online Business Profile for Local Professionals',
    description: 'Create a public profile where local customers can understand your services, area, contact details and route to book or enquire.',
    image: '/public-assets/features/public-profile/offlico-public-profile-feature-loop-poster.jpg',
  },
  {
    slug: 'leads',
    title: 'Local Customer Leads for Mobile Businesses',
    description: 'Receive relevant local service requests inside Offlico, review the customer details and turn suitable enquiries into appointments.',
    image: '/public-assets/features/leads/offlico-leads-feature-loop-poster.jpg',
  },
  {
    slug: 'stock',
    title: 'Stock Management for Mobile Service Businesses',
    description: 'Track products, materials and stock used or sold through mobile appointments, with low-stock information kept close to the work.',
    image: '/public-assets/features/stock/offlico-stock-feature-loop-poster.jpg',
  },
  {
    slug: 'team',
    title: 'Team Scheduling Software for Mobile Businesses',
    description: 'Give staff their own access while owners keep a clear shared calendar, staff filters and visibility across mobile appointments.',
    image: '/public-assets/features/team/offlico-team-feature-loop-poster.jpg',
  },
  {
    slug: 'offline-mode',
    title: 'Offline Business App for Mobile Professionals',
    description: 'Open and complete appointments and record payment status when mobile signal is weak, then sync the work when the connection returns.',
    image: '/public-assets/features/offline-mode/offlico-offline-mode-feature-loop-poster.jpg',
  },
]

const FEATURE_PAGE_HEADINGS = {
  calendar: 'The best scheduling software for mobile professionals',
  'online-booking-page': 'The best online booking software for mobile professionals',
  'ai-receptionist': 'The best AI receptionist for mobile professionals',
  'smart-routing': 'The best route planning software for mobile professionals',
  'services-and-prices': 'The best service pricing software for mobile professionals',
  'client-records': 'The best client record software for mobile professionals',
  reminders: 'The best appointment reminder software for mobile professionals',
  payments: 'The best payment software for mobile professionals',
  'tap-to-pay': 'The best Tap to Pay app for mobile professionals',
  'invoices-and-receipts': 'The best invoice software for mobile professionals',
  'documents-and-notes': 'The best document management software for mobile professionals',
  'mileage-tracking': 'The best mileage tracking software for mobile professionals',
  bookkeeping: 'The best bookkeeping software for mobile professionals',
  reports: 'The best reporting software for mobile professionals',
  'public-profile': 'The best local profile software for mobile professionals',
  leads: 'The best lead generation software for mobile professionals',
  stock: 'The best stock management software for mobile professionals',
  team: 'The best team management software for mobile professionals',
  'offline-mode': 'The best offline app for mobile professionals',
}

const FEATURE_SEARCH_INTENTS = {
  calendar: 'appointment scheduling software for mobile businesses',
  'online-booking-page': 'online booking software for mobile service businesses',
  'ai-receptionist': 'AI receptionist for mobile service businesses',
  'smart-routing': 'route planning software for mobile appointments',
  'services-and-prices': 'service pricing and booking software',
  'client-records': 'client management software for mobile businesses',
  reminders: 'appointment reminder software for small businesses',
  payments: 'payment tracking for mobile service businesses',
  'tap-to-pay': 'tap to pay for mobile service businesses',
  'invoices-and-receipts': 'invoice app for mobile businesses',
  'documents-and-notes': 'client notes and document management software',
  'mileage-tracking': 'mileage tracking app for sole traders',
  bookkeeping: 'bookkeeping app for mobile businesses',
  reports: 'business reporting software for mobile services',
  'public-profile': 'online business profile for local professionals',
  leads: 'local customer leads for mobile businesses',
  stock: 'stock management for mobile service businesses',
  team: 'team scheduling software for mobile businesses',
  'offline-mode': 'offline business app for mobile professionals',
}

export const NEW_HUB_FEATURE_ROUTE_META = FEATURE_ROUTE_SEO.map((feature) => ({
  ...feature,
  path: `/for-businesses/features/${feature.slug}`,
  pageHeading: FEATURE_PAGE_HEADINGS[feature.slug],
  pageIntro: feature.description,
  searchIntent: FEATURE_SEARCH_INTENTS[feature.slug],
}))

// The business pages; /for-businesses (the home) is served at
// www.offlico.com/ (src/utils/siteDomains.js). LocalPickr's customer pages
// have their own repo (Rithik-bot/localpickr).
export const CORE_NEW_HUB_ROUTE_META = [
  {
    path: '/for-businesses',
    title: 'Business Software for Mobile Professionals',
    description: 'Run bookings, clients, reminders, payments, invoices, mileage and daily admin in one connected app for mobile and home-visit businesses.',
    image: '/public-assets/all-mobile-businesses/main-scenes/offlico-business-homepage-mobile-professional-seated-by-car.webp',
    pageHeading: 'The best all in one software for mobile professionals',
    searchIntent: 'business software for mobile professionals',
  },
  {
    path: '/for-businesses/features',
    title: 'Mobile Business Software Features',
    description: 'Explore Offlico features for appointment scheduling, online booking, reminders, payments, invoices, mileage, client records, leads and teams.',
    image: DEFAULT_IMAGE,
    pageHeading: 'Ranked number 1 software for mobile professionals.',
    searchIntent: 'mobile business software features',
  },
  {
    path: '/for-businesses/pricing',
    title: 'Mobile Business Software Pricing',
    description: 'Compare Offlico plans for scheduling, online booking, appointment reminders, payments, client records, mileage and business admin.',
    image: DEFAULT_IMAGE,
    pageHeading: 'Offlico pricing for mobile service businesses',
    searchIntent: 'mobile business software pricing',
  },
  {
    path: '/for-businesses/contact',
    title: 'Contact Offlico for Business Support',
    description: 'Contact Offlico about business software, account setup, plan selection, onboarding and support for mobile service professionals.',
    image: DEFAULT_IMAGE,
    pageHeading: "We're here to help.",
    searchIntent: 'Offlico business support',
  },
  {
    path: '/for-businesses/switch',
    title: 'Switch Your Mobile Business to Offlico',
    description: 'Move bookings, client records, reminders, invoices, payments and mobile business admin from scattered tools into one connected workflow.',
    image: DEFAULT_IMAGE,
    pageHeading: 'Move to Offlico. We’ll handle the move.',
    searchIntent: 'switch mobile business software',
  },
  {
    path: '/for-businesses/all-mobile-businesses',
    title: 'Best Software for Mobile Businesses UK',
    description: 'Explore Offlico for mobile and home-visit businesses. Compare how scheduling, online booking, client records, reminders, payments and mileage work together.',
    image: '/public-assets/all-mobile-businesses/main-scenes/offlico-all-mobile-businesses-hero-professional.webp',
    pageHeading: 'The best software for mobile businesses',
    searchIntent: 'best software for mobile businesses uk',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      '@id': `${MARKETING_SITE_URL}/what-is-offlico/#software`,
      name: 'Offlico',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'iOS, Web',
      url: `${MARKETING_SITE_URL}/`,
      areaServed: { '@type': 'Country', name: 'United Kingdom' },
      description: 'Offlico helps mobile and home-visit businesses manage bookings, client records, reminders, payments, invoices, mileage and daily admin.',
    },
  },
  {
    path: '/for-businesses/all-mobile-businesses/online-booking',
    title: 'Online Booking Software for Mobile Professionals',
    description: 'Let customers book or request mobile services online while appointments, postcodes, reminders, payments and admin stay connected in Offlico.',
    image: '/public-assets/all-mobile-businesses/online-booking/main-scenes/offlico-mobile-professional-online-booking-home-visit-missed-calls-hero.webp',
    pageHeading: 'Are missed calls costing you bookings?',
    searchIntent: 'online booking software for mobile professionals',
  },
]

export const FEATURE_ROUTE_ALIASES = {
  invoices: 'invoices-and-receipts',
  mileage: 'mileage-tracking',
  booking: 'online-booking-page',
  services: 'services-and-prices',
  clients: 'client-records',
  documents: 'documents-and-notes',
  profile: 'public-profile',
  routing: 'smart-routing',
  iphone: 'tap-to-pay',
  android: 'tap-to-pay',
  'tap-to-pay-on-iphone': 'tap-to-pay',
  'tap-to-pay-on-android': 'tap-to-pay',
  'auto-reminders': 'reminders',
  'automatic-reminders': 'reminders',
  'automated-reminders': 'reminders',
}

const exactRouteSeo = new Map(
  [...CORE_NEW_HUB_ROUTE_META, ...BUSINESS_PROFESSION_ROUTE_META, ...NEW_PROFESSION_ROUTE_META, ...NEW_HUB_FEATURE_ROUTE_META]
    .map((item) => [item.path, item]),
)

export function normaliseMarketingPath(pathname = '/') {
  const path = String(pathname || '/').split(/[?#]/, 1)[0] || '/'
  return path === '/' ? '/' : `/${path.replace(/^\/+|\/+$/g, '')}`
}

export function servedMarketingPath(pathname = '/') {
  const path = normaliseMarketingPath(pathname)
  return path === '/' ? '/' : `${path}/`
}

export function getNewHubRouteSeo(pathname = '/') {
  const path = normaliseMarketingPath(pathname)
  const exact = exactRouteSeo.get(path)
  if (exact) return exact

  const featurePrefix = '/for-businesses/features/'
  if (path.startsWith(featurePrefix)) {
    const rawSlug = path.slice(featurePrefix.length)
    const canonicalSlug = FEATURE_ROUTE_ALIASES[rawSlug]
    if (canonicalSlug) {
      const canonicalPath = `${featurePrefix}${canonicalSlug}`
      const canonicalSeo = exactRouteSeo.get(canonicalPath)
      return canonicalSeo ? { ...canonicalSeo, canonicalPath } : null
    }
  }

  for (const profession of BUSINESS_PROFESSION_SEO) {
    const singularBase = `/for-businesses/${profession.singularSlug}`
    if (path === singularBase || path.startsWith(`${singularBase}/`)) {
      const canonicalPath = path.replace(singularBase, `/for-businesses/${profession.pluralSlug}`)
      const canonicalSeo = exactRouteSeo.get(canonicalPath)
      return canonicalSeo ? { ...canonicalSeo, canonicalPath } : null
    }
  }

  return null
}

// "<title> | Offlico".
export function formatMarketingSeoTitle(title = '', brand = 'Offlico') {
  const cleanTitle = String(title || '').trim().replace(/\s*\|\s*Offlico$/, '')
  if (!cleanTitle) return brand
  return `${cleanTitle} | ${brand}`
}
